import React, { forwardRef } from 'react'

import { Button, ButtonProps } from '../Button'
import { Icon } from '../Icon'
import { Box } from '../Box'
import { BoxProps } from '@chakra-ui/core'

type _ButtonProps = Omit<
  ButtonProps,
  'loadingText' | 'isFullWidth' | 'leftIcon' | 'rightIcon' | 'iconSpacing' | 'children'
>

export interface IconButtonProps extends _ButtonProps {
  icon?: string | BoxProps['as']
  isRound?: boolean
  children?: React.ReactNode
}

export const IconButton = forwardRef(
  ({ icon, isRound, 'aria-label': ariaLabel, children, ...restProps }: IconButtonProps, ref) => {
    return (
      <Button
        p={0}
        borderRadius={isRound ? 'full' : 'lg'}
        ref={ref}
        aria-label={ariaLabel}
        hasDepth={false}
        fontFamily="heading"
        {...restProps}
      >
        {typeof icon === 'string' ? (
          <Icon name={icon} focusable={false} color="currentColor" aria-hidden />
        ) : (
          <Box as={icon} aria-hidden color="currentColor" />
        )}

        {children}
      </Button>
    )
  },
)

IconButton.displayName = 'IconButton'

export default IconButton
